import { render, staticRenderFns } from "./ProblemType.vue?vue&type=template&id=bc8d972a&scoped=true&"
import script from "./ProblemType.vue?vue&type=script&lang=js&"
export * from "./ProblemType.vue?vue&type=script&lang=js&"
import style0 from "./ProblemType.vue?vue&type=style&index=0&id=bc8d972a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc8d972a",
  null
  
)

export default component.exports